import script from "./site-creation-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./site-creation-form.vue?vue&type=script&setup=true&lang=ts"

import "./site-creation-form.vue?vue&type=style&index=0&id=37697209&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37697209"]])

export default __exports__